import {FC} from 'react';
import {IMemoryCluster} from '@kcast-fe/core';
import {useScreenSize} from 'ui-kit';
import {Box, Flex, Stack} from '@chakra-ui/react';

interface IProps {
  clusters: IMemoryCluster[];
  selectedId?: number;
  onSelect: (id: number) => void;
}

const MemoryClusterTabsFC: FC<IProps> = ({clusters, selectedId, onSelect}) => {
  const {isLessThan768} = useScreenSize();

  return (
    <Stack
      h={'100%'}
      gap={'4px'}
      overflowY={'auto'}
      p={isLessThan768 ? '0 8px 8px 12px' : '0 8px 8px 20px'}
      css={{scrollbarWidth: 'none', '&::-webkit-scrollbar': {display: 'none'}}}
    >
      {clusters.map((cluster) => {
        const isActive = cluster.id === selectedId;

        return (
          <Flex
            key={cluster.id}
            gap={'6px'}
            flexShrink={0}
            alignItems={'center'}
            justifyContent={'space-between'}
            borderRadius={'24px'}
            p={'8px 12px'}
            cursor={'pointer'}
            bg={isActive ? '{colors.bgMain}' : 'transparent'}
            color={isActive ? '{colors.textPrimary}' : '{colors.textSecondary}'}
            transition={'background var(--tr-100-ei), color var(--tr-100-ei)'}
            _hover={{color: '{colors.textPrimary}'}}
            onClick={() => onSelect(cluster.id)}
          >
            <Box fontWeight={'500'} fontSize={'14px'}>
              {cluster.title}
            </Box>
            {cluster.count !== undefined && (
              <Box
                fontSize={'12px'}
                fontWeight={'500'}
                borderRadius={'10px'}
                p={'0 8px'}
                flexShrink={0}
                bg={'{colors.bgSurface}'}
                color={'{colors.textTertiary}'}
              >
                {cluster.count}
              </Box>
            )}
          </Flex>
        );
      })}
    </Stack>
  );
};

export const MemoryClusterTabs = MemoryClusterTabsFC;
